import {
  ODataHeader,
  ODataString,
  ODataDate,
  ODataBoolean,
  ODataDecimal,
  ODataInteger
} from "pbas-vue-components";

import { translate2 } from '../trans2'

/*
insuranceCarriersDisplayFunc(item) {
      return item.insuranceCarriers.map(ic => ic.name).join(", ");
    },
    employersDisplayFunc(item) {
      return item.employers.map(ic => ic.name).join(", ");
    },
    billingPaymentStatusDisplayFunc(item) {
      var ret = true;
      item.employers.forEach(ic => {
        ret = ret && ic.amount == ic.totalAmount;
      });
      return ret;
    },
    billingPaymentStatusIndeterminateFunc(item) {
      return (
        item.employers.filter(ic => ic.amount === ic.totalAmount).length !==
          item.employers.length &&
        item.employers.filter(ic => ic.amount === ic.totalAmount).length > 0
      );
    },
    premiumsPaymentStatusDisplayFunc(item) {
      var ret = true;
      item.insuranceCarriers.forEach(ic => {
        ret = ret && ic.amount == ic.totalAmount;
      });
      return ret;
    },
    premiumsPaymentStatusIndeterminateFunc(item) {
      return (
        item.insuranceCarriers.filter(ic => ic.amount === ic.totalAmount)
          .length !== item.insuranceCarriers.length &&
        item.insuranceCarriers.filter(ic => ic.amount === ic.totalAmount)
          .length > 0
      );
    },
*/
const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});
const PlanBalanceStoresHeaders = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    isIdentifier: true,
    version: 1
  }),
  new ODataHeader({
    title: "HasPaymentsHistory",
    type: new ODataBoolean("HasPaymentsHistory"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.number",
    type: new ODataString("Number"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "components.employers.search_employers_form.store_name",
    type: new ODataString("Name"),
    sortable: true,
    visible: false,
    searchable: true,
    allowVisibilityChange: false,
    version: 1
  }),
  new ODataHeader({
    title: "components.employers.search_employers_form.store_name",
    type: new ODataString("Translations[]/Name", {
      getString: (item) => translate2(item, "Name")
    }),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
    version: 1,
    orderByKey: "Name"
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "headers.plan_balance.last_payment_date",
    type: new ODataDate("LastPaymentDate"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.plan_balance.current_balance",
    type: new ODataDecimal("CurrentBalance", {
      getString: (item, type) => {
        const value = item.CurrentBalance;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true
  })
];
export default PlanBalanceStoresHeaders;